import { createContext, useContext, useMemo } from 'react';
import { useMyTeamOptional } from './MyTeamContext';
import { assignTeamColors, teamColorVar } from '../utils/teamColors';

const NEUTRAL = {
  colorFor: () => teamColorVar(null),
  isMine: () => false,
  youSlot: null,
};

const TeamColorsContext = createContext(NEUTRAL);

export function TeamColorsProvider({ leagueId, teamIds, children }) {
  const myTeamId = useMyTeamOptional()?.myTeamId ?? null;
  // A joined key keeps the memo stable when the caller passes a fresh array each render.
  const teamKey = (teamIds ?? []).join(',');

  const colors = useMemo(
    () => assignTeamColors(leagueId, teamKey ? teamKey.split(',') : []),
    [leagueId, teamKey],
  );

  const value = useMemo(() => {
    const mine = myTeamId == null ? null : String(myTeamId);
    return {
      colorFor: (teamId) => teamColorVar(colors.get(String(teamId))),
      isMine: (teamId) => mine !== null && String(teamId) === mine,
      youSlot: mine === null ? null : colors.get(mine) ?? null,
    };
  }, [colors, myTeamId]);

  return <TeamColorsContext.Provider value={value}>{children}</TeamColorsContext.Provider>;
}

export function useTeamColors() {
  return useContext(TeamColorsContext);
}
